import { useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';

import { AppContext, EMPTY_OBJECT } from 'commons-ui';

import useService from '../../../useService';

import { FORM_FIELD_CONFIG, FORM_FIELD_KEYS } from '../../formConfig';
import { dehydrateFormData } from '../../../utils/formDataParser';
import { IWebsiteUpdateV2 } from '../../../apkUpdateInfoModel';

const useCreate = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { showAlert } = useContext(AppContext);
	const history = useHistory();
	const { requestCreateWebsiteUpdateInfoV2, getLudoVersionNumberOptions, getDashBoardNamesOptions, getTestBucketsNamesOptions } =
		useService();
	FORM_FIELD_CONFIG[FORM_FIELD_KEYS.DASHBOARD_NAME].setRenderProps({ getOptions: getDashBoardNamesOptions });
	FORM_FIELD_CONFIG[FORM_FIELD_KEYS.VERSION].setRenderProps({ getOptions: getLudoVersionNumberOptions });
	FORM_FIELD_CONFIG[FORM_FIELD_KEYS.WEBSITE_NAME].setRenderProps({ options: [{ label: 'zupee.com', id: 'zupee.com' }] });
	FORM_FIELD_CONFIG[FORM_FIELD_KEYS.BUCKET_NAME].setRenderProps({ getOptions: getTestBucketsNamesOptions });
	FORM_FIELD_CONFIG[FORM_FIELD_KEYS.CONTROL_BUCKET_NAME].setRenderProps({ options: [{ label: 'control', id: 'control' }] });

	const createWebsiteUpdateInfoV2 = (createdData: IWebsiteUpdateV2) => {
		setShowLoader(true);
		try {
			showAlert('Website Update Info created called');
			requestCreateWebsiteUpdateInfoV2(createdData);
			showAlert('Website Update Info created');
			history.goBack();
		} catch (error: any) {
			showAlert(`Error: ${error.response.data.error}`, { type: 'error' });
		} finally {
			setShowLoader(false);
		}
	};

	const handleFormSubmit = (submittedData: any) => {
		createWebsiteUpdateInfoV2(dehydrateFormData(submittedData));
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return { data: EMPTY_OBJECT, showLoader, handleFormSubmit, handleFormCancel, setShowLoader };
};

export default useCreate;
